// extracted by mini-css-extract-plugin
export default {"alignIcon":"styles_alignIcon__uyqIW"};